module.exports = __webpack_public_path__ + "static/media/fam-home.ab6366f9.png";